import { render, staticRenderFns } from "./UserProfileInfoMobile.vue?vue&type=template&id=ac7694a8&scoped=true&"
import script from "./UserProfileInfoMobile.vue?vue&type=script&lang=ts&"
export * from "./UserProfileInfoMobile.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfileInfoMobile.vue?vue&type=style&index=0&id=ac7694a8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7694a8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BixUserAvatar: require('/root/project/frontend/src/components/user/BixUserAvatar.vue').default,CompanyAvatar: require('/root/project/frontend/src/components/CompanyAvatar.vue').default})
